var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.85 36.95",
    style: {
      enableBackground: "new 0 0 48.85 36.95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.07,35.94H13.91c-1.32,0-2.4-1.08-2.4-2.4c0-1.33,1.07-2.4,2.4-2.4h32.16c1.32,0,2.4,1.07,2.4,2.4 C48.47,34.87,47.4,35.94,46.07,35.94L46.07,35.94z M46.07,35.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.07,20.88H13.91c-1.32,0-2.4-1.07-2.4-2.4c0-1.32,1.07-2.4,2.4-2.4h32.16c1.32,0,2.4,1.08,2.4,2.4 C48.47,19.8,47.4,20.88,46.07,20.88L46.07,20.88z M46.07,20.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.07,5.81H13.91c-1.32,0-2.4-1.08-2.4-2.4c0-1.33,1.07-2.4,2.4-2.4h32.16c1.32,0,2.4,1.07,2.4,2.4 C48.47,4.74,47.4,5.81,46.07,5.81L46.07,5.81z M46.07,5.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.82,3.6c0,1.78-1.44,3.22-3.22,3.22c-1.78,0-3.22-1.44-3.22-3.22c0-1.78,1.44-3.22,3.22-3.22 C5.38,0.38,6.82,1.82,6.82,3.6L6.82,3.6z M6.82,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.82,18.48c0,1.78-1.44,3.22-3.22,3.22c-1.78,0-3.22-1.44-3.22-3.22c0-1.78,1.44-3.22,3.22-3.22 C5.38,15.25,6.82,16.7,6.82,18.48L6.82,18.48z M6.82,18.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.82,33.36c0,1.78-1.44,3.22-3.22,3.22c-1.78,0-3.22-1.44-3.22-3.22c0-1.78,1.44-3.22,3.22-3.22 C5.38,30.13,6.82,31.58,6.82,33.36L6.82,33.36z M6.82,33.36"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documentsIcon.104cb5514c366b6da6a5f62d9989eabd.svg";
export { ForwardRef as ReactComponent };